import * as React from "react";
import { PaperClipIcon } from "@heroicons/react/solid";

interface FileInputProps {
  disabled?: boolean;
  placeholder: string;
  onChange?: (file: File) => void;
  accept?: string
}

const FileInput: React.FunctionComponent<FileInputProps> = ({
  disabled,
  placeholder,
  onChange,
  accept
}) => {
  const inputRef = React.createRef<HTMLInputElement>();
  const [file, setFile] = React.useState<File>();

  const openFileUpload = () => inputRef.current.click();
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const f = event.target.files[0];
    setFile(f);
    onChange(f);
  };

  return (
    <div className="relative overflow-hidden">
      <button
        type="button"
        onClick={openFileUpload}
        className="bg-white flex items-center w-full h-11 shadow-sm rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 mt-1 resize-none leading-6 transition-colors duration-200 ease-in-out"
      >
        <PaperClipIcon
          className="h-6 w-6 mr-2 group-hover:text-gray-500 shrink-0"
          aria-hidden="true"
        />
        <span className="text-sm text-gray-500 group-hover:text-gray-600 italic  shrink-0 mr-2">
          {placeholder}
        </span>
        <span className="text-base leading-8 text-gray-700 ml-auto w-1/2 text-ellipsis overflow-hidden text-right">
          {file?.name}
        </span>
      </button>
      <input
        className="h-[1px] w-full absolute bottom-0 opacity-0"
        ref={inputRef}
        required={true}
        type="file"
        onChange={handleFileUpload}
        disabled={disabled}
        accept={accept}
      />
    </div>
  );
};

export default FileInput;
